import { HTMLAttributes } from 'react';
import clsx from 'clsx';
import styles from './BrandTitle.module.scss';

type ColorVariant = 'white' | 'orange';

interface BrandTitleProps
  extends Omit<HTMLAttributes<HTMLHeadingElement>, 'children'> {
  firstLine: string;
  secondLine?: string;
  firstLineColor?: ColorVariant;
  secondLineColor?: ColorVariant;
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  className?: string;
}

export default function BrandTitle({
  firstLine,
  secondLine,
  firstLineColor = 'white',
  secondLineColor = 'orange',
  as: Tag = 'h2', // Polymorphic component pattern: rename 'as' prop to 'Tag' for use as JSX element
  className = '',
  ...props
}: BrandTitleProps) {
  const titleClasses = clsx(styles.brandTitle, className);

  return (
    <Tag className={titleClasses} {...props}>
      <span className={styles[firstLineColor]}>{firstLine}</span>
      {secondLine && (
        <>
          <span className={styles[secondLineColor]}>{secondLine}</span>
        </>
      )}
    </Tag>
  );
}
